<div class="grid" style="margin-top: 8px;" *ngIf="(deviceMeasurements && deviceMeasurements.length > 0)">
  <div class="col-12">
    <div class="flex flex-column sm:flex-row justify-content-between card">
      <div class="flex flex-column xl:flex-row">
        <p-calendar
          [firstDayOfWeek]="1"
          [(ngModel)]="rangeDates"
          [readonlyInput]="false"
          [style]="{'min-width': '180px'}"
          selectionMode="range"
          styleClass="w-full"
          dateFormat="dd/mm/yy"
          inputId="range"
        >
        </p-calendar>
        <p-multiSelect
          [(ngModel)]="selectedMeasurements"
          [placeholder]="'select.sensors' | transloco"
          [options]="deviceMeasurements"
          [selectedItemsLabel]="'{0} ' + ('misc.sensorsSelected' | transloco).toLowerCase()"
          [maxSelectedLabels]="1"
          [filter]="true"
          (onChange)="loadMeasurementUnits()"
          class="mt-2 xl:mt-0 xl:ml-2"
          styleClass="w-full"
          optionLabel="name"
          optionValue="uuid"
          filterBy="nameDesc"
        ></p-multiSelect>
        <p-button
          [label]="'common.search' | transloco"
          [disabled]="loadingMeasures || !rangeDates || !rangeDates[1]"
          (onClick)="searchMeasures()"
          class="mt-2 xl:mt-0 xl:ml-2"
          styleClass="w-full"
        ></p-button>
      </div>
      <div class="flex flex-column sm:flex-row justify-content-center p-fluid">
        <button
          *ngIf="'ROLE_ADMIN' | userHasRole"
          [label]="'common.importCsv' | transloco"
          pButton
          class="p-button-secondary md:mr-2"
          routerLink="../measurements/import"
          icon="pi pi-upload"
        ></button>
        <p-selectButton
          [(ngModel)]="selectedModeOption"
          [options]="modeOptions"
          class="mt-2 sm:mt-0"
          styleClass="w-full"
          optionLabel="label"
        ></p-selectButton>
      </div>
    </div>
  </div>
</div>
<div class="grid" style="margin-top: 1px;" *ngIf="deviceMeasurements && deviceMeasurements.length > 0">
  <div class="col-12">
    <div class="card" style="min-height: 570px;">
      <div class="flex flex-column sm:flex-row justify-content-between">
        <h4>{{'model.measures' | transloco}}</h4>
        <div class="flex flex-column sm:flex-row justify-content-center p-fluid">
          <button type="button" pButton icon="pi pi-bars" label="{{'common.actions' | transloco}}" (click)="menu.toggle($event)"></button>
          <p-menu #menu [popup]="true" [model]="actionsMeasure" id="options">
          </p-menu>
        </div>
      </div>
      <hr>
      <div class="flex">
        <div *ngIf="displayActionsDialog" style="min-width: 250px;">
          <div class="flex flex-row-reverse">
            <button pButton pRipple type="button" icon="pi pi-times" class="p-button-rounded p-button-text" (click)="hideConversions()"></button>
          </div>
          <div >
            <p-table [value]="groupedMeasurementUnit" [scrollable]="true" scrollHeight="400px">
              <ng-template let-item pTemplate="body">
                <div class="col-12">
                  <div class="col-12">
                    <label>{{item.measure}}</label>
                  </div>
                  <div class="col-12">
                    <p-dropdown
                      [(ngModel)]="selectedMeasurementsUnit[item.measure]"
                      [placeholder]="'select.unit' | transloco"
                      [options]="item.items"
                      [filter]="true"
                      class="mt-2 xl:mt-0 xl:ml-0"
                      optionLabel="target"
                      styleClass="customStyle"
                      appendTo="body"
                      [style]="{'min-width': '150px'}"
                      filterBy="target"
                    >
                      <ng-template let-selected pTemplate="selectedItem">{{selected.name}}</ng-template>
                      <ng-template let-possibility pTemplate="item">{{possibility.name}}</ng-template>
                    </p-dropdown>
                  </div>
                </div>
              </ng-template>
              <ng-template pTemplate="emptymessage">
                <tr>
                  <td colspan="6" >
                    <p class="w-full text-xl text-center p-6 font-italic">{{ 'empty.measuresWithUnitSelected' | transloco }}</p>
                  </td>
                </tr>
              </ng-template>

            </p-table>
            <div class="col-12">
              <p-button [label]="'common.restore' | transloco" (onClick)="clearConversions()" styleClass="p-button-danger" type="button"></p-button>
              <p-button [label]="'primeng.apply' | transloco" (onClick)="searchMeasures()" styleClass="p-button-primary mx-2 mt-2" type="button"></p-button>
            </div>
          </div>
        </div>
        <div [style.width]="displayActionsDialog ? 'calc(100% - 250px)' : '100%'">
          <app-generic-graph
            *ngIf="graphMeasures && !loadingMeasures && selectedModeOption.value === 'chart'"
            [name]="'attribute.value' | transloco"
            [data]="graphMeasures"
            [height]="500"
            [yAxis]="graphAxis"
            [customSeries]="true"
            [legend]="true"
            chartType="line"
            tooltipDecimalPlaces="3"
            tooltipDateFormat="%A, %e %b %Y, %H:%M:%S %Z"
            #measuresChart
          ></app-generic-graph>
          <app-table-skeleton *ngIf="loadingMeasures && selectedModeOption.value === 'chart'"
                              [rows]="12"
          ></app-table-skeleton>
          <p-table
            *ngIf="tableMeasures && selectedModeOption.value === 'table'"
            [value]="tableMeasures"
            [paginator]="true"
            [(first)]="first"
            [(rows)]="rows"
            [totalRecords]="totalMeasures"
            [sortOrder]="-1"
            sortField="timestamp"
          >
            <ng-template pTemplate="header">
              <tr>
                <th pSortableColumn="measurementName">
                  {{'model.measurement' | transloco}} <p-sortIcon field="measurementName"></p-sortIcon></th>
                <th pSortableColumn="timestamp">
                  {{'attribute.timestamp' | transloco}} <p-sortIcon field="timestamp"></p-sortIcon></th>
                <th pSortableColumn="value">
                  {{'attribute.value' | transloco}} <p-sortIcon field="value"></p-sortIcon></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-measure>
              <tr *ngIf="!loadingMeasures">
                <td>
                  <span class="p-column-title bold">{{'model.measurement' | transloco}}</span>
                  {{measure.measurementName}}
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.timestamp' | transloco}}</span>
                  {{measure.timestamp | customDate: ({showTimezone: true})}}
                </td>
                <td>
                  <span class="p-column-title bold">{{'attribute.value' | transloco}}</span>
                  {{(measure.value | formatNumber) + ' ' + (measure.unit ?? '')}}
                </td>
              </tr>
              <tr *ngIf="loadingMeasures">
                <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
                <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
                <td class="row-height-sm"><p-skeleton height="1em"></p-skeleton></td>
              </tr>
            </ng-template>
            <ng-template pTemplate="summary">
              <div class="flex align-items-center justify-content-between" *ngIf="totalMeasures == 0">
                {{'pagination.empty' | transloco}}
              </div>
              <div class="flex align-items-center justify-content-between" *ngIf="totalMeasures > 0">
                {{'pagination.showing' | transloco}} {{first+1}}
                {{'pagination.to' | transloco}} {{(first+rows) >= totalMeasures ? totalMeasures : (first+rows)}}
                {{'pagination.of' | transloco}} {{totalMeasures}}
                {{(totalMeasures > 1 ? 'pagination.entries':'pagination.entry') | transloco}}
              </div>
            </ng-template>
          </p-table>
        </div>
      </div>
      <div [style.display]="mapMeasures !== undefined ? 'block' : 'none'" class="rounded" id="map"></div>
    </div>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="deviceMeasurements && deviceMeasurements.length == 0">
  <div class="card w-full">
    <div class="flex flex-column sm:flex-row justify-content-end">
      <button
        *ngIf="'ROLE_ADMIN' | userHasRole"
        [label]="'common.importCsv' | transloco"
        pButton
        class="p-button-secondary md:mr-2"
        routerLink="../measurements/import"
        icon="pi pi-upload"
      ></button>
    </div>
    <p class="text-xl text-center p-6 font-italic mb-4">{{'empty.measures' | transloco}}</p>
  </div>
</div>
<div class="flex" style="margin-top: 15px;" *ngIf="!deviceMeasurements">
  <div class="card w-full">
    <app-table-skeleton [rows]="14"></app-table-skeleton>
  </div>
</div>

<app-export-xls *ngIf="exportVisible"
                [content]="tableMeasures"
                [first]="first"
                [typeExport]="typeExport"
                [typeContent]="'MEASUREMENTS'"
                [(visible)]="exportVisible">
</app-export-xls>
